import { MainApplicationForm } from "../../pages/recruitment/application-form";

const ApplicationForm = () => <MainApplicationForm />;

export default ApplicationForm;
